import React from 'react';
import { Link } from 'react-router-dom';
import { FAQ_BLURB } from '../../mock';
import { ArrowRight } from 'lucide-react';

export default function FinalCTA() {
  return (
    <section id="apply" className="relative py-24 md:py-32 overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[600px] rounded-full bg-amber-300/[0.06] blur-3xl" />
      </div>
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-serif text-white text-[40px] md:text-[64px] leading-[1.05] tracking-tight whitespace-pre-line">
          {FAQ_BLURB.heading}
        </h2>
        <p className="mt-7 max-w-2xl mx-auto text-neutral-400 text-[15px] md:text-[17px] leading-relaxed">
          {FAQ_BLURB.sub}
        </p>
        <div className="mt-10">
          <Link
            to="/apply"
            className="group inline-flex items-center gap-2 rounded-full px-8 py-4 text-[15px] font-medium text-navy-900 bg-gradient-to-b from-amber-200 to-amber-400 shadow-[0_10px_36px_-6px_rgba(251,191,36,0.55)] hover:-translate-y-[2px] hover:shadow-[0_16px_44px_-6px_rgba(251,191,36,0.75)] transition-all"
          >
            {FAQ_BLURB.cta}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
}
